// src/components/AccountCreation/Step0_PlanSelection.js
import React, { useState, useEffect } from 'react';
import { PLAN_FEATURES } from './constants';

const Step0_PlanSelection = ({ data, setData, nextStep, apiData, setApiParams, apiParams, apiLoading, apiError, handleFetchPlans }) => {
    const { planId, frequency, price, tierName } = data.subscription;
    const cleanTierName = (name) => name ? name.replace('Acuma', '').replace('SUBS_', '').replace('Intl', '') : '';

    const handleApiParamsChange = (field, value) => {
        setApiParams(prev => ({ ...prev, [field]: value }));
    };

    const availableTiers = ['Bronze', 'Gold', 'Premium'];
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        if (availableTiers.length > 1) {
            const timer = setTimeout(() => {
                setActiveSlide((prev) => (prev + 1) % availableTiers.length);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [activeSlide, availableTiers.length]);

    return (
        <div className="step-content text-center">
            <h2 className="step-title">Select Device Type & Region</h2>
            <p className="step-subtitle mb-2">Choose your device type and region to see available plans</p>
            {/* <div className="row g-0"> */}
            {/* Column 1: Plan Features Slider */}
            {/* <div className="col-lg-6">
                    <div className="plan-slider-container">
                        <div className="plan-slider" style={{ transform: `translateX(-${activeSlide * 100}%)` }}>
                            {availableTiers.map((tier) => (
                                <div className="plan-slide" key={tier}>
                                    <div className={`view-plan-feature-card plan-${cleanTierName(tier).toLowerCase()}`}>
                                        <div className="card-header">
                                            <h3 className="fw-bold h4">{cleanTierName(tier)}</h3>
                                        </div>
                                        <div className="card-body">
                                            <ul className="list-unstyled feature-list">
                                                {PLAN_FEATURES[cleanTierName(tier)]?.map((feature, i) => (
                                                    <li key={i}><i className="bi bi-check-circle-fill me-2"></i>{feature}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="slider-thumbnails">
                        {availableTiers.map((tier, index) => (
                            <div
                                key={tier}
                                className={`thumbnail-item ${index === activeSlide ? 'active' : ''}`}
                                onClick={() => setActiveSlide(index)}
                                title={`View ${cleanTierName(tier)} plan`}
                            >
                                <div className={`thumbnail-preview plan-${cleanTierName(tier).toLowerCase()}`}></div>
                                <span>{cleanTierName(tier)}</span>
                            </div>
                        ))}
                    </div>
                </div> */}
            {/* Column 2: Plan Selection Form */}
            {/* <div className="col-lg-6"> */}
            <div className="plan-selection-form mx-auto" style={{ maxWidth: '550px' }}>
                <div className="mb-4 text-start">
                    <label htmlFor="deviceType" className="form-label fw-bold">Device Type <span className="text-danger">*</span></label>
                    <select
                        id="deviceType"
                        className="form-select"
                        value={apiParams.device_type}
                        onChange={(e) => handleApiParamsChange('device_type', parseInt(e.target.value, 10))}
                        disabled={apiLoading}
                    >
                        <option value="">Select a Device</option>
                        <option value={2}>Android</option>
                        <option value={1}>iOS</option>
                    </select>
                </div>
                <div className="mb-4 text-start">
                    <label htmlFor="region" className="form-label fw-bold">Region <span className="text-danger">*</span></label>
                    <select
                        id="region"
                        className="form-select"
                        value={apiParams.region_code}
                        onChange={(e) => handleApiParamsChange('region_code', e.target.value)}
                        disabled={apiLoading}
                    >
                        <option value="">Select a Region</option>
                        <option value="us_ca">US/Canada</option>
                        <option value="uk">UK</option>
                        <option value="intl">International</option>
                    </select>
                </div>

                {apiParams.region_code === 'uk' && (
                    <div className="uk-redirect-link text-center mb-4 small p-2 rounded bg-light border">
                        <p className="mb-0">For purchases in the UK, please visit our <a href="https://epilepsysolutions.co.uk/" target="_blank" rel="noopener noreferrer">UK Store</a>.</p>
                    </div>
                )}

                {apiParams.region_code !== 'uk' && apiError && <div className="alert alert-danger text-center">{apiError}</div>}

                <div className="text-end mt-4">
                    <button onClick={handleFetchPlans} className="btn btn-primary" disabled={!apiParams.device_type || !apiParams.region_code || apiLoading || apiParams.region_code === 'uk'}>
                        {apiLoading ? "Fetching plans..." : "CONTINUE"}
                    </button>
                </div>
            </div>
            {/* </div>
            </div> */}
            <style>{`
                .plan-slider-container {
                    position: relative;
                    overflow: hidden;
                    border-radius: 0.5rem 0 0 0.5rem; /* Rounded corners for desktop view */
                    min-height: 450px;
                    padding-top: 1rem;
                }
                .plan-slider {
                    display: flex;
                    transition: transform 0.5s ease-in-out;
                }
                .plan-slide {
                    flex: 0 0 100%;
                    padding: 1rem;
                }
                .view-plan-feature-card {
                    border: 1px solid transparent;
                    border-radius: 0.5rem;
                    height: 100%;
                    color: #fff;
                }
                .view-plan-feature-card .card-header { text-align: center; background: none; border: none; }
                .view-plan-feature-card .feature-list { padding: 0 1.5rem 1rem; }
                .view-plan-feature-card .feature-list li { margin-bottom: 0.75rem; }
                
                .slider-thumbnails {
                    display: flex;
                    justify-content: center;
                    gap: 1rem;
                    padding: 1rem;
                }
                .thumbnail-item {
                    cursor: pointer;
                    text-align: center;
                    opacity: 0.6;
                    transition: all 0.3s ease;
                }
                .thumbnail-item:hover { opacity: 1; }
                .thumbnail-item.active {
                    opacity: 1;
                    font-weight: bold;
                    transform: scale(1.05);
                }
                .thumbnail-preview {
                    width: 70px;
                    height: 45px;
                    border-radius: 0.35rem;
                    margin-bottom: 0.5rem;
                    border: 3px solid transparent;
                    transition: border-color 0.3s ease;
                }
                .thumbnail-item.active .thumbnail-preview {
                    border-color: var(--bs-primary);
                }
                .plan-selection-form {
                    padding: 2rem;
                    background-color: #ffffff;
                    border-radius: 0 0.5rem 0.5rem 0;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                }

                /* --- MOBILE RESPONSIVE STYLES --- */
                @media (max-width: 768px) {
                    .plan-slider-container {
                        /* On mobile, top corners are rounded */
                        border-radius: 0.5rem 0.5rem 0 0;
                        min-height: auto; /* Let content define height */
                    }
                    .plan-slide {
                        padding: 1rem 1rem 0; /* Reduce padding */
                    }
                    .plan-selection-form {
                        /* On mobile, bottom corners are rounded */
                        border-radius: 0 0 0.5rem 0.5rem;
                        padding: 1.5rem; /* Reduce padding */
                        justify-content: flex-start;
                    }
                     .slider-thumbnails {
                        /* This will now sit between the slider and the form */
                        border-radius: 0;
                        background-color: #ffffff;
                        padding-top: 0;
                    }
                    .plan-selection-form .btn {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default Step0_PlanSelection;
